
import { MobileNav } from '@/components/Layout'
import { Sidebar } from '@/components/Layout/Sidebar'
import AuthMixin from '@/mixins/authMixin'
import PortalMixin from '@/mixins/portalMixin'
import { defineComponent } from 'vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'

/**
 * Active user layout
 */
export default defineComponent({
  name: 'UserLayout',
  components: {
    Sidebar,
    MobileNav
  },
  meta: {
    auth: {
      strict: true,
      redirectToLogin: true
    }
  },
  head: {
    bodyAttrs: {
      class: 'antialiased stroke-2 hide-scroll'
    }
  },
  mixins: [AuthMixin, PortalMixin, ActiveUserMixin],
  async fetch(): Promise<void> {
    this.fetchActiveUser({})
  },
  watch: {
    '$route.path': {
      handler() {
        this.resetScroll()
      }
    }
  },
  methods: {
    resetScroll() {
      const divThatScrolls = this.$refs['scrolling-div'] as HTMLElement
      if (divThatScrolls) divThatScrolls.scrollTop = 0
    }
  }
})
